import { render } from "./CollectionMoney.vue?vue&type=template&id=275a7b43&scoped=true"
import script from "./CollectionMoney.vue?vue&type=script&lang=js"
export * from "./CollectionMoney.vue?vue&type=script&lang=js"

import "./CollectionMoney.vue?vue&type=style&index=0&id=275a7b43&scoped=true&lang=less"

import exportComponent from "D:\\phpstudy_pro\\WWW\\guolang\\partner\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-275a7b43"]])

export default __exports__